import React from 'react';
import PropTypes from 'prop-types';

import Text from './components/Text';
import Options from './components/Options';

function CartItemDescription({ items, showErrors }) {
  if (!items || !items.length) return null;

  const filteredOptionsGroups = items.filter(
    optionGroup => optionGroup.options && optionGroup.options.length > 0,
  );

  return filteredOptionsGroups.map(optionGroup => {
    const { id, name, options, notAvailable } = optionGroup;

    return (
      <Text key={id} notAvailable={notAvailable} showError={showErrors}>
        {`${name}: `}
        <Options options={options} showErrors={showErrors} />
      </Text>
    );
  });
}

CartItemDescription.propTypes = {
  items: PropTypes.array,
  showErrors: PropTypes.bool,
};

CartItemDescription.defaultProps = {
  items: [],
  showErrors: false,
};

export default React.memo(CartItemDescription);
